exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".vOCFJbGq-perzdZhz7W1p{width:200px}", ""]);

// exports
exports.locals = {
	"dropdown": "vOCFJbGq-perzdZhz7W1p"
};